import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthenticationService } from '../business/user/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  public orderInvalid$: BehaviorSubject<boolean>;

  constructor(
    private auth: AuthenticationService

  ) {
    this.orderInvalid$ = new BehaviorSubject(false);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
      

        // En cas d'accès interdit, on déconnecte l'utilisateur, TEMPORAIRE POUR REGLER ERREUR URGENTE DE L'USURPATION TOKEN
        if (error.status === 403) {
            this.auth.logout();
        }

        return throwError(error);
      })
    );
  }
}
